(function () {

  var FIELD_LABELS = {
    'delivery-method': 'Delivery method',
    'address-type':    'Address type',
    'loading-dock':    'Loading dock',
    'phone':           'Freight contact phone',
  };

  // ── Per-container init ────────────────────────────────────────────────────
  window.__cdqInitWrap = function (container) {
    if (!container || container.dataset.cdqInit) return;
    container.dataset.cdqInit = '1';

    var touched = false;

    function qs(sel)    { return container.querySelector(sel); }
    function qsAll(sel) { return container.querySelectorAll(sel); }

    function getMissingFields() {
      var dmChecked = qs('[name="attributes[Delivery Method]"]:checked');
      var ldChecked = qs('[name="attributes[Loading Dock]"]:checked');
      var isShipping = dmChecked && dmChecked.value === 'Freight Shipping';
      var missing = [];
      if (!dmChecked) missing.push('delivery-method');
      if (isShipping) {
        if (!qs('[name="attributes[Address Type]"]:checked'))    missing.push('address-type');
        if (!ldChecked)                                           missing.push('loading-dock');
        var phone = qs('#cdq-freight-phone');
        if (!phone || !phone.value.trim())                        missing.push('phone');
      }
      return missing;
    }

    function applyHighlights(missing) {
      qsAll('[data-cdq-field]').forEach(function (el) { el.classList.remove('cdq-invalid'); });
      var phoneInput = qs('#cdq-freight-phone');
      if (phoneInput) phoneInput.classList.remove('cdq-invalid');
      if (!touched) return;
      missing.forEach(function (field) {
        var el = qs('[data-cdq-field="' + field + '"]');
        if (el) el.classList.add('cdq-invalid');
        if (field === 'phone' && phoneInput) phoneInput.classList.add('cdq-invalid');
      });
    }

    function applyCheckoutState(missing) {
      var isValid = missing.length === 0;
      document.querySelectorAll('#checkout, button[name="checkout"]').forEach(function (btn) {
        btn.disabled = !isValid;
        // Morph guard: morphSection() strips JS-set attributes to match server HTML.
        // Watch for disabled being removed and immediately re-add it if still invalid.
        if (!btn.__cdqMorphGuard) {
          btn.__cdqMorphGuard = new MutationObserver(function () {
            if (!btn.disabled && getMissingFields().length > 0) {
              btn.disabled = true;
            }
          });
          btn.__cdqMorphGuard.observe(btn, { attributes: true, attributeFilter: ['disabled'] });
        }
      });
      var notice = document.getElementById('cdq-checkout-notice');
      if (!notice) return;
      if (!isValid && touched) {
        var labels = missing.map(function (f) { return FIELD_LABELS[f] || f; });
        notice.innerHTML = '&#9888; Please complete before checking out: <strong>' + labels.join(', ') + '</strong>';
        notice.classList.add('cdq-notice-visible');
      } else {
        notice.innerHTML = '';
        notice.classList.remove('cdq-notice-visible');
      }
    }

    function cdqUpdate() {
      var missing = getMissingFields();
      applyHighlights(missing);
      applyCheckoutState(missing);
    }

    container.addEventListener('change', function (e) {
      if (e.target.name && e.target.name.indexOf('attributes[') === 0) cdqUpdate();
    });
    container.addEventListener('input', function (e) {
      if (e.target.id === 'cdq-freight-phone') cdqUpdate();
    });

    container.__cdqGetMissing = getMissingFields;

    container.__cdqTouch = function () {
      touched = true;
      cdqUpdate();
      var firstInvalid = qs('[data-cdq-field].cdq-invalid');
      if (firstInvalid) firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    cdqUpdate();
  };

  // ── Disabled checkout click → show errors ─────────────────────────────────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('#checkout, button[name="checkout"]');
    if (btn && btn.disabled) {
      document.querySelectorAll('.cdq-wrap[data-cdq-init]').forEach(function (wrap) {
        if (wrap.offsetParent !== null && wrap.__cdqTouch) wrap.__cdqTouch();
      });
    }
  });

  // ── Re-apply checkout state across all live CDQ wraps ────────────────────
  window.__cdqReapplyAll = function () {
    document.querySelectorAll('.cdq-wrap[data-cdq-init]').forEach(function (wrap) {
      var missing = wrap.__cdqGetMissing ? wrap.__cdqGetMissing() : [];
      document.querySelectorAll('#checkout, button[name="checkout"]').forEach(function (btn) {
        btn.disabled = missing.length > 0;
      });
    });
  };

  // ── MutationObserver — catches dynamically injected .cdq-wrap containers ──
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('cdq-wrap')) window.__cdqInitWrap(node);
        if (node.querySelectorAll) node.querySelectorAll('.cdq-wrap').forEach(window.__cdqInitWrap);
        // If a checkout button was re-injected (e.g. after first add-to-cart), re-apply state
        if (
          node.id === 'checkout' ||
          (node.querySelectorAll && node.querySelectorAll('#checkout, button[name="checkout"]').length)
        ) {
          window.__cdqReapplyAll();
        }
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  // ── Init containers already in DOM at script-load time ───────────────────
  document.querySelectorAll('.cdq-wrap').forEach(window.__cdqInitWrap);

})();
